import { render, staticRenderFns } from "./Volumes.vue?vue&type=template&id=4c5817cf&scoped=true&"
import script from "./Volumes.vue?vue&type=script&lang=js&"
export * from "./Volumes.vue?vue&type=script&lang=js&"
import style0 from "./Volumes.vue?vue&type=style&index=0&id=4c5817cf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5817cf",
  null
  
)

export default component.exports